import keyMirror from 'src/utilities/keyMirror';

const PREFIX = 'AUTO_REPORT';

export const ACTION_TYPES = keyMirror({
  [`${PREFIX}_LOAD_CONFIG`]: null,
  [`${PREFIX}_LOAD_CONFIG_SUCCESS`]: null,
  [`${PREFIX}_LOAD_CONFIG_FAILED`]: null,
});
